import { $api } from "@/shared/api";

// Сводка тренировки (`GET /api/drills/overview`): сколько задач ждёт, дни подряд,
// последняя серия и темы игрока.
export const useDrillsOverview = () => $api.useQuery("get", "/api/drills/overview");
